// extracted by mini-css-extract-plugin
export var messageSideLeft = "_od-1";
export var messageSideRight = "_od-2";
export var orderLookupBubbleContainer = "_od-0";
export var submitButton = "_od-3";